export default __webpack_public_path__ + "static/media/50.bc1fee88.png";